import React, { useEffect } from 'react';
import Navbar from '../../Navbar';
import Hero from '../../Hero';
import ComparisonTable from '../../ComparisonTable';
import Pricing from '../../Pricing';
import McpSection from '../../McpSection';
import Footer from '../../Footer';
import { usePageMeta } from '../../../lib/usePageMeta';

const MainPage: React.FC = () => {
  usePageMeta({
    title: 'The Local Licensed Professional Database API',
    description: 'The definitive API for verifying licensed professionals. Check active status, exact geo-location, and tenure for Realtors, Dentists, and Insurance Agents in real-time.',
    path: '/',
  });
  useEffect(() => {
    const hash = window.location.hash.replace('#', '');
    if (hash) {
      setTimeout(() => {
        const element = document.getElementById(hash);
        if (element) {
          const yOffset = -80;
          const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
          window.scrollTo({ top: y, behavior: 'smooth' });
          history.replaceState(null, '', window.location.pathname);
        }
      }, 300);
    }
  }, []);

  return (
    <div className="bg-slate-900 min-h-screen text-white font-sans antialiased selection:bg-sky-500/30 selection:text-sky-200">
      <Navbar />
      <main>
        <Hero />
        <ComparisonTable />
        <Pricing />
        <McpSection />
      </main>
      <Footer />
    </div>
  );
};

export default MainPage;